"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _logger = require("@insided/shared/services/logger");

var _header = _interopRequireDefault(require("../../control-components/header"));

var _Robots = _interopRequireDefault(require("./Robots"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Seo = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Seo, _Component);

  var _super = _createSuper(Seo);

  function Seo(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Seo);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "endpoints", void 0);
    _this.state = {
      robots: '',
      isLoading: false,
      messageType: null
    };
    _this.endpoints = {
      getData: '/seo/getRobots',
      saveData: '/seo/updateRobots'
    };
    _this.onRobotTextChanged = _this.onRobotTextChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSave = _this.onSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Seo, [{
    key: "onRobotTextChanged",
    value: function onRobotTextChanged(value) {
      this.setState({
        robots: value
      });
    }
  }, {
    key: "onSave",
    value: function () {
      var _onSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true,
                  messageType: null
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.post(this.endpoints.saveData, {
                  robots: this.state.robots
                });

              case 4:
                this.setState({
                  isLoading: false,
                  messageType: 'success'
                });
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                this.setState({
                  isLoading: false,
                  messageType: 'error'
                });

                _logger.logger.error(_context.t0, {
                  component: 'Seo',
                  action: 'onSave'
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function onSave() {
        return _onSave.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.get(this.endpoints.getData);

              case 3:
                _yield$axios$get = _context2.sent;
                data = _yield$axios$get.data;
                this.setState({
                  robots: data.robots
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                _logger.logger.error(_context2.t0, {
                  component: 'Seo',
                  action: 'componentDidMount'
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          robots = _this$state.robots,
          isLoading = _this$state.isLoading,
          messageType = _this$state.messageType;
      return (0, _preact.h)("div", null, (0, _preact.h)(_header.default, {
        title: "Robots.txt",
        isLoading: isLoading,
        saveCallback: this.onSave
      }), messageType ? (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        isVisibleFor: 3000
      }) : null, (0, _preact.h)(_Robots.default, {
        data: robots,
        onChange: this.onRobotTextChanged
      }));
    }
  }]);
  return Seo;
}(_preact.Component);

var _default = Seo;
exports.default = _default;